export { default } from '@roots/bud-client/dom-ready';
